// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SjxG","col":"styles_col__36dWq"};